import { useContext } from 'react';
import EntraIdContext from 'contexts/EntraIdContext';

const useAuthEntra = () => {
  const context = useContext(EntraIdContext);
  
  if (!context) {
    throw new Error("useAuthEntra must be used within an EntraIdProvider");
  }

  return context;
};

export default useAuthEntra;